/**
 * Gets the user agent or null if running server-side
 * @returns {string|null} The user agent or null
 */

function getUserAgent() {
  if (typeof window === "undefined") return null;
  return window.navigator.userAgent.toLowerCase();
}

/**
 * Detects if the current request is from a bot
 * @returns {boolean} True if the request is from a bot, false otherwise
 */
function isBot() {
  const userAgent = getUserAgent();
  if (!userAgent) return false;

  const botKeywords = [
    "googlebot",
    "bingbot",
    "yandexbot",
    "baiduspider",
    "duckduckbot",
    "slurp",
    "twitterbot",
    "facebookexternalhit",
    "linkedinbot",
    "pinterest",
    "slackbot",
    "telegrambot",
    "applebot",
    "skypeuripreview",
    "discordbot",
    "bot/",
    "/bot",
    "crawler/",
    "spider/",
  ];

  return botKeywords.some((bot) => userAgent.includes(bot));
}

/**
 * Determines if third-party content should be rendered
 * @returns {boolean} True if third-party content should be rendered
 */
export function isRegularUser() {
  // Don't render third-party content for bots
  return !isBot();
}
